import React from "react";
import * as S from "./styles";

export function ReviewCard({ text, name, title, size = "small", onClick }) {
  const isLarge = size === "large";

  return (
    <S.CardWrapper $isLarge={isLarge} onClick={onClick}>
      <S.TextContent>
        <S.Quotes $isLarge={isLarge} />
        <S.ReviewText $isLarge={isLarge}>{text}</S.ReviewText>
      </S.TextContent>
      <S.AuthorInfo $isLarge={isLarge}>
        <S.AuthorName $isLarge={isLarge}>{name}</S.AuthorName>
        <S.AuthorCEO $isLarge={isLarge}>{title}</S.AuthorCEO>
      </S.AuthorInfo>
    </S.CardWrapper>
  );
}
